export default __webpack_public_path__ + "static/media/trash_white.ecaa2fc5.svg";